/**
 *
 * @module entry
 * @desc {SDK.Services.Internal.Dust} entry point.
 *
 */

import DustApplicationPayload from '../dust/dustApplicationPayload';
import DustCategory from '../dust/dustCategory';
import DustClientPayload from '../dust/dustClientPayload';
import DustDevicePayload from '../dust/dustDevicePayload';
import DustLogUtility from './../dust/dustLogUtility';
import DustPayload from '../dust/dustPayload';
import DustSdkPayload from '../dust/dustSdkPayload';
import DustServerPayload from '../dust/dustServerPayload';
import DustUrnReference from './../dust/dustUrnReference';

/**
 *
 * @typedef SDK.Services.Internal.Dust
 * @type {Object}
 *
 * @property {DustApplicationPayload} DustApplicationPayload
 * @property {DustCategory} DustCategory
 * @property {DustClientPayload} DustClientPayload
 * @property {DustDevicePayload} DustDevicePayload
 * @property {DustLogUtility} DustLogUtility
 * @property {DustPayload} DustPayload
 * @property {DustSdkPayload} DustSdkPayload
 * @property {DustServerPayload} DustServerPayload
 * @property {DustUrnReference} DustUrnReference
 */

/**
 *
 * @type {SDK.Services.Internal.Dust}
 *
 */
export default {

    DustApplicationPayload,
    DustCategory,
    DustClientPayload,
    DustDevicePayload,
    DustLogUtility,
    DustPayload,
    DustSdkPayload,
    DustServerPayload,
    DustUrnReference

};



// WEBPACK FOOTER //
// ./src/services/internal/dust/entry.js